// Copyright (c) Docugami, Inc. All rights reserved.
import React from 'react';
import { Modal, Button } from "@fluentui/react";
import { DgHorizontalSpacer, DgFlexSpacer, DgVerticalSpacer } from '../../common/DgCommonStyledComponents';

export interface ModalViewerProps {
    hidden: boolean;
    title: string;
    dismissedCallback: () => void;
    children: JSX.Element;
}

export const ModalViewer = (props: ModalViewerProps): JSX.Element => {
    return (
        <Modal
            titleAriaId={props.title}
            isOpen={!props.hidden}
            onDismiss={props.dismissedCallback}
            isBlocking={false}
            scrollableContentClassName="noscroll"
            dragOptions={undefined}>
            <div style={{height: 0.95 * window.innerHeight, width: 0.95 * window.innerWidth, display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div style={{flex:1}}/>
                    <Button onClick={props.dismissedCallback}>X</Button>
                </div>
                <DgVerticalSpacer height={"20px"}/>
                <div className="scrollYOnHover" style={{flex: 1, width: '100%', display: 'flex', flexDirection: 'row'}}>
                    <DgHorizontalSpacer width={"20px"}/>
                    <DgFlexSpacer>
                        {props.children}
                    </DgFlexSpacer>
                    <DgHorizontalSpacer width={"20px"}/>
                </div>
                <DgVerticalSpacer height={"20px"}/>
            </div>
        </Modal>
    )
}
